import React, { useEffect } from "react";
import Classes from "./styles/style.module.css";
// import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import { useDispatch, useSelector } from "react-redux";
import BlogFilters from "./BlogFilters";
import BlogRequests from "../../assets/services/blog";
import { setBlogFilter } from "../../assets/redux/actions/Blog";
import AllBlogs from "./AllBlogs";
import Loading from "../../assets/containers/loadingDialog";
import { useLocation } from "react-router-dom";

const Blog = () => {
  const dispatch = useDispatch();
  const { bLogFilter, fetchBlogsLoading } = useSelector(({ blog }) => blog);
  const location = useLocation();
  const locationQuery = new URLSearchParams(location.search);
  const searchQuery = locationQuery.get("searchString");

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(BlogRequests.getAllblogs(bLogFilter, 1));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [bLogFilter, dispatch]);

  return (
    <>
      <div className={Classes.blogPageContainer}>
        <BlogFilters
          selected={bLogFilter}
          handleClick={(filter) => dispatch(setBlogFilter(filter))}
          searchQuery={searchQuery}
        />
        {fetchBlogsLoading ? (
          <Loading
            className={"w-100 d-flex justify-content-center my-5 py-5"}
          />
        ) : (
          <AllBlogs />
        )}
      </div>
    </>
  );
};

export default Blog;
